import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  totalSelectedDocuments: number
  loading: boolean
  onSubmit: () => void
  onClose: () => void
}

const HideModal = ({ totalSelectedDocuments, loading, onSubmit, onClose }: Props) => {
  return (
    <Modal
      illustration="visibility"
      title={i18n.t('documents.employee.bulk-actions.hide-dialog.title', {
        count: totalSelectedDocuments,
      })}
      description={i18n.t('documents.employee.bulk-actions.hide-dialog.description')}
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <Button submit loading={loading}>
          {i18n.t('documents.employee.bulk-actions.hide-dialog.submit')}
        </Button>
      }
    />
  )
}

export default HideModal
